import { Address } from '@portal/models/address';

interface AddressRow extends Address {
  area?: string;
}

export function addressToString(address: Address) {
  if (!address) {
    return '';
  }

  return `${addSeparate(address.countryWithId?.country?.title)}${addSeparate(address?.region?.title)}${addSeparate(
    address?.city,
  )}${address?.addressLine || ''}`;
}

export function addressToCordString(address: AddressRow): string {
  if (!address) {
    return '';
  }

  return [
    address?.addressLine,
    address?.city,
    address?.area,
    address?.district,
    address?.region?.title,
    address?.postalCode,
  ]
    .filter(Boolean)
    .join(' ');
}

function addSeparate(line: string): string {
  return line ? line + ', ' : '';
}
